export function debug(msg, data) {
  log('debug', msg, data);
};

export function info(msg, data) {
  log('info', msg, data);
};

export function warn(msg, data) {
  log('warn', msg, data);
};

export function error(msg, data) {
  log('warn', msg, data);
};

const log = (level, msg, data) => {
  console.log(msg+' : '+JSON.stringify(data, null, 2));
};
